import { cssClasses } from './variables.js';
import { modalAndOverlayStyleHandler } from './styleHandlers.js';

export let modalState = {
    body: null,
    modals: [],
    modalOverlay: null,
    animationSpeed: 0
};

export const closeEvents = (event) => {
    const { body, modals, modalOverlay: overlay, animationSpeed } = modalState;
    const button = document.querySelector('[data-modalButton].isActive');
    const modal = modals.find((modal) => modal.classList.contains(cssClasses.isActive));
    const closeButton = modal?.querySelectorAll('[data-modalClose]');

    //When modal closed, find the data-modal-open and dispatch modalClosed event with the value
    const modalClosed = modal.querySelector('[data-modal-open]')?.dataset.modalOpen;
    console.log("modalclosed", modalClosed);
    if (modalClosed) {
        console.log("modalclosed", modalClosed);
        document.dispatchEvent(new CustomEvent('modalClosed', {
            bubbles: true,
            detail: {
                modalName: modalClosed,
            }
        }));
    }

    eventListenerManager(body, button, modal, overlay, animationSpeed, false, closeButton);
};

export const buttonEvents = (event) => {
    const { body, modals, modalOverlay: overlay, animationSpeed } = modalState;
    const button = event.target.closest('[data-modalButton]');
    const buttonTarget = button.getAttribute('data-target');
    const modal = modals.find((modal) => modal.id === buttonTarget);
    if (!modal) return;
    const closeButton = modal.querySelectorAll('[data-modalClose]');
    eventListenerManager(body, button, modal, overlay, animationSpeed, true, closeButton);
};

function eventListenerManager(body, button, modal, overlay, animationSpeed, addStyle, closeButton) {
    modalAndOverlayStyleHandler(body, button, {
        'overlay': overlay,
        'modal': modal
    }, closeButton, animationSpeed, addStyle);

    if (addStyle) {
        button.removeEventListener('click', buttonEvents);
        overlay.addEventListener('click', closeEvents);
        closeButton?.forEach(button => button.addEventListener('click', closeEvents));
        //closeButton?.addEventListener('click', closeEvents);
    } else {
        overlay.removeEventListener('click', closeEvents);
        button.addEventListener('click', buttonEvents);
        closeButton?.forEach(button => button.addEventListener('click', closeEvents));
        //closeButton?.removeEventListener('click', closeEvents);
    }
}